module.exports = __webpack_public_path__ + "static/img/deng3.74075f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongqiu/deng3.png
// module id = 2vBy
// module chunks = 1